import type { HTMLMotionProps } from 'motion/react';
import type {
  ComponentProps,
  ComponentPropsWithRef,
  ElementType,
  PropsWithChildren,
  PropsWithRef,
} from 'react';

export enum Sort {
  desc = 'desc',
  asc = 'asc',
}

export type TableHeadCellProps = PropsWithChildren<ComponentProps<'th'>> & {
  sortable?: boolean;
  active?: boolean;
  sort?: Sort;
  defaultSort?: Sort;
  onSortToggle?: () => void;
  sortableClassName?: string;
  contentClassName?: string;
  DescIcon?: any;
  AscIcon?: any;
};
export type TableRowProps = PropsWithChildren<ComponentProps<'tr'>>;

/** Polymorphic table row: when `as` is provided, props follow that component's props. */
export type PolymorphicTableRowProps<C extends ElementType = 'tr'> = {
  as?: C;
} & Omit<ComponentPropsWithRef<C>, 'as'>;
export type TableAnimatableRowProps = HTMLMotionProps<'tr'>;

export type TableFooterProps = PropsWithChildren<ComponentProps<'tfoot'>> & {
  tdClassName?: string;
};

export type TableHeadProps = PropsWithChildren<ComponentProps<'thead'>>;

export type TableCellProps = PropsWithChildren<ComponentProps<'td'>>;

export type TableBodyProps = PropsWithChildren<ComponentProps<'tbody'>>;

export type TableProps = PropsWithChildren<ComponentProps<'table'>> & {
  tableClassName?: string;
  innerWrapperClassName?: string;
};

export type sorter = { cellId: string; direction: Sort };

export type onSort = (cellId: string) => void;

export type Sorter = { cellId: string; direction: Sort };

export type OnSortFunc = (cellId: string) => void;

export type SortProps = {
  sortable?: boolean;
  active?: boolean;
  sort?: Sort;
  onSortToggle?: () => void;
  defaultSort?: Sort;
};
